module.exports = __webpack_public_path__ + "img/juan.d3cf9b1d.png";